import createReactComponent from '../createReactComponent';
export default createReactComponent('upload', 'Upload', [["path",{"d":"M4 16.004V17a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1m-8-.5v-11M15.5 8 12 4.5 8.5 8","key":"svg-0"}]]);